/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import './stylesheets.css'
import '../components/global/tailwind.css'
import { initSentry } from '../config/sentry';
import { analytics } from '@heycatch/sdk';

// Initialize Sentry BEFORE ReactRailsUJS wires up components so any
// mount-time throw is captured. `initSentry` no-ops outside
// production builds so dev/test don't ship events.
initSentry();

// HeyCatch analytics for the marketing site. This app runs on React 16, which
// @heycatch/sdk doesn't peer-support (it targets React 18+), so we use the
// framework-agnostic 'web' mode — the SDK's React integration is optional and
// stays untouched here. Anonymous only (no logged-in user on the marketing
// surface); identity is wired in the SPA's AuthContext.
analytics.init({
  projectKey: 'hck_pk_2B_aamOUgFWi5ybfPK79PWxgfgS_h4QA',
  install: { framework: 'web', frameworkVersion: '16', agent: 'claude-code' },
});

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
